module.exports = __webpack_public_path__ + "static/img/4.d226ffe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/zh/4.png
// module id = vzmV
// module chunks = 0